import { queryOptions } from '@tanstack/react-query';

import { buildURL, patch, post } from '@/shared/fetch';

import { getQueryFn } from '../utils';
import {
  GetProductsParams,
  GetProductsResponse,
  GetUserProductsParams,
  GetUserProductsResponse,
  GetUserRetentionOffersResponse,
  PatchUserProductParams,
  PatchUserProductResponse,
  PostUserProductRequest,
  PostUserProductResponse,
  PostUserRetentionOfferRequest,
  PostUserRetentionOfferResponse,
} from './types';

export const getProductsQueryOptions = (params?: GetProductsParams) =>
  queryOptions({
    queryKey: ['products', 'list', params],
    queryFn: getQueryFn<GetProductsResponse>('/v2/products', params),
  });

export const getUserProductsQueryOptions = (params?: GetUserProductsParams) =>
  queryOptions({
    queryKey: ['user-products', 'list', params],
    queryFn: getQueryFn<GetUserProductsResponse>('/v2/users/products', params),
  });

export const patchUserProductMutationFn = async ({ userProductId, ...params }: PatchUserProductParams) => {
  const response = await patch<PatchUserProductResponse>(buildURL(`/v2/users/products/${userProductId}`), params);
  if (response) {
    // extend the response to 2 seconds to wait for the new product webhook to be processed
    return new Promise((resolve) => setTimeout(() => resolve(response), 2000));
  }
  return response;
};

export const getUserRetentionOffersQueryOptions = (userProductId: string) =>
  queryOptions({
    queryKey: ['retention-offers', 'list', userProductId],
    queryFn: getQueryFn<GetUserRetentionOffersResponse>(`/v2/users/products/${userProductId}/retentionOffers`),
  });

export const postUserProductMutationFn = async (args: PostUserProductRequest) => {
  return post<PostUserProductResponse>(buildURL('/v2/users/products'), args);
};

export const postUserRetentionOfferMutationFn = async ({ userProductId, ...args }: PostUserRetentionOfferRequest) => {
  return post<PostUserRetentionOfferResponse>(buildURL(`/v2/users/products/${userProductId}/retentionOffers`), args);
};
